import type { HeaderProps } from './header.types';
import { cn } from '@/utils/helper';
import v1 from './header-v1.module.css';
import v2 from './header-v2.module.css';

export default function Header(props: HeaderProps) {
  return <div className={cn(v1.Header, v2.Header)}>{props.content}</div>;
}
